
const FIXED_TIME = 15
export default {
  data () {
    return {
      // 导出参数配置:
      exportObj: {
        isExport: 1,
        excelNames: '',
        excelKeys: '',
        contextmenuWrap: [],
        sort: {},
        search: {}
      },
      computedTime: FIXED_TIME
    }
  },
  methods: {
    batchExport (listName) {
      let tableColumn = listName['tableColumns']
      let strName = ''
      let strKey = ''
      tableColumn.forEach(item => {
        if (item.prop === 'rowNumber') return false
        strName += ',' + item.label
        strKey += ',' + item.prop
      })
      this.exportObj['excelNames'] = strName.slice(1)
      this.exportObj['excelKeys'] = strKey.slice(1)
      this.exportObj['contextmenuWrap'] = listName['tableQuery']['contextmenuWrap']
      this.exportObj['search'] = listName['tableQuery']['search']
      this.exportObj['sort'] = listName['tableQuery']['sort']
      if (this.computedTime === FIXED_TIME) {
        this.setExportByPage()
        this.$message({
          dangerouslyUseHTMLString: true,
          type: 'success',
          message: `<strong>${this.$t('operation.tips_export')}</strong>`,
          duration: 5000,
          offset: 80
        })
      } else {
        this.$message({ message: this.$t('messageTip.operateRepeat'), type: 'warning' })
      }
    },
    setExportByPage () {
      this.ExportByPage()
      this.timer = setInterval(() => {
        this.computedTime--
        if (this.computedTime === 0) {
          clearInterval(this.timer)
          this.computedTime = FIXED_TIME
        }
      }, 1000)
    }
  }
}
